import React, {  } from 'react';
import { Typography } from '@mui/material';
import { FieldType } from '../../../../../hooks/useSchema';
import { ContactsListData } from '../../../data/useContactsList';
import { useContactAttributesConfig } from '../../../data/useContactAttributesConfig';
import { CRMAttributeConfig, CustomAttributeType } from '../../..//types';
import { FormControlsForFields } from '../../../../schemed';
import { ExtraProps } from '../../../../schemed/FormControlProps';
import { AutoSuggest, AutoSuggestMultiple } from '../../../../primitives/AutoSuggests';

export const crmAttributeSuggestionsKey = (code: string) => `_tl_crm_attribute_suggestions_${code}`;

export interface CustomAttributeControlProps {
  attribute: CRMAttributeConfig;
  editRecord: Pick<ContactsListData["editRecord"], "item" | "update">;
  attributesConfig: ReturnType<typeof useContactAttributesConfig>;
}

export const CustomAttributeControl = (props: CustomAttributeControlProps) => {
  const { attribute, editRecord, attributesConfig } = props;
  const options: ExtraProps | undefined = attribute.type === FieldType.select
    ? { autoComplete: true }
    : (attribute.type as any) === CustomAttributeType.suggest
      ? { control: AutoSuggest, suggestionsKey: crmAttributeSuggestionsKey(attribute.code) }
      : (attribute.type as any) === CustomAttributeType.suggest_multi
        ? { control: AutoSuggestMultiple, suggestionsKey: crmAttributeSuggestionsKey(attribute.code) }
        : undefined;
  
  let itemAttributes = editRecord.item?.attributes || {};
  if(((attribute.type as any) === CustomAttributeType.suggest_multi || attribute.type === FieldType.multiselect)
    && !!itemAttributes[attribute.code] && !Array.isArray(itemAttributes[attribute.code])) {
      // this may happen if custom attribute type was switched
      // if it was not an array we need to prevent crash
      itemAttributes = {};
  }

  return (
    <FormControlsForFields
      key={`${editRecord.item?._id}_${attribute.code}_control`}
      fields={[
        [attribute.code, { label: " ", ...(options || {}) }],
      ]}
      schema={attributesConfig.schema}
      data={itemAttributes}
      onChange={(o, c) => editRecord.update({ attributes: { ...o, ...c } })}
    />
  );
};

export interface CustomAttributesEditorsProps {
  editRecord: ContactsListData["editRecord"];
  attributesConfig: ReturnType<typeof useContactAttributesConfig>;
}

export const CustomAttributesEditors = ({ editRecord, attributesConfig }: CustomAttributesEditorsProps) => {
  const contactCategories = editRecord.item?.categories || [];

  const visibleAttributes = attributesConfig.attributes.filter((f: any) => 
    !f.available_for_categories?.length ||
    (f.available_for_categories || []).some((category: string) => contactCategories.includes(category))
  );

  return (
    <>
      {visibleAttributes.map((attribute: any) => (
        <React.Fragment key={attribute.code}>
          <Typography variant="caption" color="textSecondary" className="attribute-label">
            {attribute.label}
          </Typography>
          <CustomAttributeControl 
            attribute={attribute} 
            editRecord={editRecord} 
            attributesConfig={attributesConfig} 
          />
        </React.Fragment>
      ))}
    </>
  );
};
